import React from "react";
import { Link } from "react-router-dom";
import content from "../content/content.json";

const IndustryExperience = () => {
  const { industryExperience, shared } = content;

  return (
    <section
      className="relative bg-cover bg-center bg-no-repeat w-full py-24 md:py-32 px-6 md:px-16 lg:px-24 flex items-center"
      style={{
        backgroundImage: `url('${industryExperience.backgroundImage}')`,
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      <div className="relative z-10 max-w-7xl mx-auto flex justify-end items-center w-full">
        <div className="bg-white/95 p-10 md:p-12 lg:p-16 shadow-lg rounded-md w-full md:w-2/3 lg:w-1/2">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#1C1F2B] mb-8 leading-tight">
            {industryExperience.heading}
          </h2>

          <div className="mb-12">
            <h3 className="text-2xl font-semibold text-gray-800 mb-4">{industryExperience.subheading}</h3>
            <ul className="list-disc pl-10 space-y-2">
            {content.industryExperience.description.map((item, index) => (
              <li key={index} className="text-gray-700">{item}</li>
            ))}
          </ul>
          </div>

          <Link to="/industries" className="more-insight-btn group relative overflow-hidden border border-[#E4002B] px-8 py-4 font-semibold rounded-none inline-flex items-center gap-2">
            <span className="relative z-10 text-white group-hover:text-[#E4002B] transition-colors duration-300">
              {industryExperience.button}
            </span>
            <span className="relative z-10 text-white text-xl group-hover:text-[#E4002B] transition-colors duration-300">
              {shared.arrow}
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default IndustryExperience;

